import isArray from './is-array';
import isString from './is-string';

function endsWith(arr, e) {
  return isArray(arr) || isString(arr) ? arr[arr.length - 1] === e : false;
}

export default endsWith;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/ends-with.js
// module id = 50
// module chunks = 0